import { render, staticRenderFns } from "./VehicleSpec.vue?vue&type=template&id=c5047a54&scoped=true&"
import script from "./VehicleSpec.vue?vue&type=script&lang=js&"
export * from "./VehicleSpec.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSpec.vue?vue&type=style&index=0&id=c5047a54&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5047a54",
  null
  
)

export default component.exports